var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrationArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.703528 0.116287C0.828219 0.0314542 0.989046 -0.00945836 1.15065 0.00254291C1.31226 0.0145442 1.46142 0.0784767 1.56534 0.180286L5.64547 4.18029C5.69921 4.23047 5.74012 4.28892 5.76579 4.3522C5.79147 4.41549 5.8014 4.48233 5.79498 4.54879C5.78857 4.61526 5.76595 4.68 5.72845 4.73922C5.69095 4.79844 5.63934 4.85093 5.57664 4.89362C5.51394 4.9363 5.44142 4.96831 5.36336 4.98776C5.28529 5.00721 5.20325 5.01371 5.12207 5.00687C5.04088 5.00004 4.96219 4.98001 4.89062 4.94797C4.81904 4.91593 4.75604 4.87251 4.70531 4.82029L0.625182 0.820287C0.521333 0.718428 0.471249 0.587051 0.485941 0.455037C0.500632 0.323023 0.578897 0.201178 0.703528 0.116287Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.703528 8.88419C0.578896 8.79929 0.500632 8.67745 0.485941 8.54543C0.471249 8.41342 0.521333 8.28204 0.625181 8.18019L4.70531 4.18019C4.75604 4.12796 4.81904 4.08455 4.89062 4.0525C4.96219 4.02046 5.04088 4.00043 5.12207 3.9936C5.20325 3.98677 5.28529 3.99327 5.36336 4.01272C5.44142 4.03217 5.51394 4.06417 5.57664 4.10686C5.63934 4.14954 5.69095 4.20203 5.72845 4.26125C5.76595 4.32047 5.78857 4.38521 5.79498 4.45168C5.8014 4.51814 5.79147 4.58498 5.76579 4.64827C5.74012 4.71155 5.69921 4.77001 5.64547 4.82019L1.56534 8.82019C1.46142 8.92199 1.31226 8.98593 1.15065 8.99793C0.989045 9.00993 0.828219 8.96902 0.703528 8.88419Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationArrowIcon);
export default __webpack_public_path__ + "static/media/integration_arrow_icon.d78a7922d40f861550440d5eb06eee74.svg";
export { ForwardRef as ReactComponent };